import { gql } from '@apollo/client';

export const RISK_LOG_CHANGE_TYPE = {
    /** 账号更换设备 */
    DEVICE_CHANGED: 'DEVICE_CHANGED',
    /** 设备更换账号 */
    ACCOUNT_CHANGED: 'ACCOUNT_CHANGED',
} as const;

export interface DriverActivityRiskLogInput {
    driverId?: number | null;
    phone?: string | null;
    startDate: string;
    endDate: string;
}

export interface DriverActivityRiskLogDriver {
    accountId: number;
    name: string;
    maskedPhone?: string | null;
}

export interface DriverActivityRiskLogItem {
    /** 后端 Long 标量，epoch 毫秒字符串 */
    changedAt: string;
    changeType: string;
    accountId: number;
    previousDeviceId?: string | null;
    currentDeviceId?: string | null;
    previousAccountId?: number | null;
    currentAccountId?: number | null;
}

export interface DriverActivityRiskDailyHit {
    /** 美西日期 yyyy-MM-dd */
    date: string;
    hitRules: string[];
}

export interface DriverActivityRiskLogPage {
    driver: DriverActivityRiskLogDriver;
    total: number;
    items: DriverActivityRiskLogItem[];
    /** null 表示命中结果暂不可用 */
    dailyHits?: DriverActivityRiskDailyHit[] | null;
}

export const PAGE_DRIVER_ACTIVITY_RISK_LOG = gql`
    query PageDriverActivityRiskLog($input: DriverActivityRiskLogInput!, $page: Int!, $size: Int!) {
        pageDriverActivityRiskLog(input: $input, page: $page, size: $size) {
            driver {
                accountId
                name
                maskedPhone
            }
            total
            items {
                changedAt
                changeType
                accountId
                previousDeviceId
                currentDeviceId
                previousAccountId
                currentAccountId
            }
            dailyHits {
                date
                hitRules
            }
        }
    }
`;

export interface PageDriverActivityRiskLogResponse {
    pageDriverActivityRiskLog: DriverActivityRiskLogPage;
}

export interface PageDriverActivityRiskLogVariables {
    input: DriverActivityRiskLogInput;
    page: number;
    size: number;
}

export const EXPORT_DRIVER_ACTIVITY_RISK_LOG = gql`
    mutation ExportDriverActivityRiskLog($input: DriverActivityRiskLogInput!, $language: String) {
        exportDriverActivityRiskLog(input: $input, language: $language) {
            success
            errorCode
            fileName
        }
    }
`;

export interface ExportDriverActivityRiskLogResponse {
    exportDriverActivityRiskLog: {
        success: boolean;
        errorCode?: string | null;
        fileName?: string | null;
    };
}

export interface ExportDriverActivityRiskLogVariables {
    input: DriverActivityRiskLogInput;
    language?: string | null;
}
